<template>
  <div style="padding: 10px;">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>Log Geral</h4>
        </div>
      </div>
    </div>
    
    <div class="col-md-12">
      <vue-good-table
        :columns="columns"
        :rows="log"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15, 25],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'status'">
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/logController.js";
import "src/controller/sistema/usuarioController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      columns: [
        {
          label: "Modulo",
          field: "modulo",
        },
        {
          label: "Tipo",
          field: "crud",
        },
        {
          label: "O que foi Alterado",
          field: "realizou",
        },
        {
          label: "Usuario que Alterou",
          field: "quem_realizou",
        },
        {
          label: "Data da Alteração",
          field: "data",
        },
        {
          label: "Horario",
          field: "horario",
          sortable: false,
        },
        {
          label: "IP",
          field: "ip",
          sortable: false,
        },
        {
          label: "id",
          field: "id",
          hidden: true,
        },
      ],
      log: [],
      user: {
        admin: null,
        admin_sistema: null,
        id: null,
      },
    };
  },
  methods: {
    async listarTudo() {
      try {
        let data = await this.$listarLogGeral();
        let listarLog = data.data.reverse();
        
        listarLog.forEach(array => {
          this.filtro(array);
        });
      } catch (e) {}
    },
    filtro(array){
      let divDateHorario = array.created_at;
      let DateHorario = divDateHorario.split(" ");
      
      // data que foi criada
      let DateDiv = DateHorario[0].split("-"); 
      let DateCompleta = DateDiv[2]+'/'+DateDiv[1]+'/'+DateDiv[0];

      // hora que foi criada
      let horaDiv = DateHorario[1]; 


      let logPerson = {
        id: array.id,
        crud: array.crud,
        modulo: array.modulo,
        realizou: array.realizou,
        quem_realizou: array.quem_realizou,
        data: DateCompleta,
        horario: horaDiv,
        ip: array.ip,
      };

      this.log.push(logPerson); 
    }
  },
  beforeMount() {
    try {
      this.listarTudo();
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
      this.user.id = store.id;
    } catch (e) {}
  },
};
</script>

